import React from 'react';
import Spinner from '@/assets/images/common/spinner.svg';

type Props = {
    label?: string;
    className?: string;
};

/**
 * パネル用ローディング
 * @param param0
 * @returns
 */
const PanelLoader: React.FC<Props> = ({ label = 'Loading…', className = '' }) => {
    return (
        <div
            className={`w-full h-full flex flex-col items-center justify-center text-gray-500 ${className}`}
        >
            <img src={Spinner} alt="loading" className="w-8 h-8 mb-2 opacity-80" />
            <span className="text-sm">{label}</span>
        </div>
    );
};

export default PanelLoader;
